import { AvailableModules } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useModuleAvailability } from 'modules/core/hooks/useModuleAvailability'

import type { AssignmentType } from 'modules/it_management/components/AssignmentForm'

export const useAssignmentFormSaveDisabled = (assignmentType: AssignmentType): boolean => {
  const { company } = useCurrentSession()
  const { moduleAvailability: spaceControlAvailability } = useModuleAvailability(
    AvailableModules.space_control,
    company.id
  )

  return assignmentType === 'space' && !spaceControlAvailability.available
}
